import React, {useEffect, useRef} 	from 'react';
import axios				from "axios";

import { useNavigate }		from "react-router";
import Box					from '@mui/system/Box';
import Stack				from '@mui/system/Stack';

//import Input				from '@mui/joy/Input';
import Autocomplete 		from '@mui/joy/Autocomplete';
import {Typography}			from '@mui/joy';
import Alert				from '@mui/joy/Alert';
import IconButton			from '@mui/joy/IconButton';
import CircularProgress 	from '@mui/joy/CircularProgress';
import AutocompleteOption 	from '@mui/joy/AutocompleteOption';
import ListItemContent 		from '@mui/joy/ListItemContent';

// Icons
import IcoSearch			from '@mui/icons-material/Search';
import IcoCloseRounded		from '@mui/icons-material/CloseRounded';
import IcoNote				from '@mui/icons-material/ReportGmailerrorred';

import {config} 			from "./config.js";


function AddTicker() {
	const [showAlert, setshowAlert] = React.useState(false);
	const [errorMsg, setErrorMsg] = React.useState("");
	const [isLoading, setLoading] = React.useState(false);
	const [options, setOptions] = React.useState([]);
	const [open, setOpen] = React.useState(false);
	const navigate = useNavigate();	
	const selectReference = useRef(null);
	
	useEffect(() => {
		let uid = localStorage.getItem("username");
		
		if (uid !== "" && uid !== null) {
			// uid found!
			console.log("Welcome again " + uid);
		}
		else {
			const dataSaved = localStorage.getItem("datasaved");
			
			// If uid not found, check if user have saved anything before (datasaved=true in local storage should show this)
			
			console.log("uid empty, check if data saved");

			if (dataSaved) {
				console.log("data saved, goto login");
				navigate('/login');
			}
			else
				console.log("No data saved");

			// Set default locale to browser
			localStorage.setItem("locale", navigator.language);			
		}

		selectReference.current.focus();
		
	}, []);	
	
    function searchTicker(query) {

		if (query == '' || typeof query == 'undefined' || query == null)
			return;

		if (typeof query == 'object') {
			query = query.Code + '.' + query.Exchange;
		}
		else
			query = query.trim();

        var url = config.IP + "/company2/" + query;
        
        setLoading(true);
		setOpen(false);        
        
		axios.get(url, {headers: {"content-type": "application/json"}})
			.then((response) => {
				console.log("respons:", response.data);
				setLoading(false);
				navigate('/showstock', {state: response.data});
			})
			.catch((error) => {
				
				if (error.response) {
					if (error.response.status == 404) {
						// Problably not a valid ticker, call search, query is a search string or name?
						axios.get(config.IP + "/search/" + query, {headers: {"content-type": "application/json"}})
						.then((response) => {
							if (response.data.length > 0) {
								console.log("response extended search:", response.data);
								setOptions([...response.data]);
								setOpen(true); // Open and display search result
							}
							else {
								setErrorMsg("Your search didn't match any company names or tickers.");
								console.error("No match on", query);
								setshowAlert(true);
							}
							setLoading(false);
						})
						.catch((error) => {
							setErrorMsg("Search: " + error.response.status);
							console.error('Search:', error.response.status);					
							setshowAlert(true);
						});
					}
					else {
						setErrorMsg("Server error: " + error.response.status);
						console.error('Server Error:', error.response.status);					
						setshowAlert(true);
					}
				} else if (error.request) {
					setErrorMsg("Network error: " + error.code);		
					console.error('Network Error:', error.code);
					setshowAlert(true);
				} else {
					setErrorMsg("Error: " + error.message);				
					console.error('Error:', error.message);
					setshowAlert(true);
				}

			});
		
    }

	return (
		<React.Fragment>

		<Stack direction="column" justifyContent="center" alignItems="center">
	  		<img src={process.env.PUBLIC_URL + '/cut-loss.png'} height={235} width={235} alt="cut your losses."/>
		 	<Typography sx={{mt:1}} align="center" level="h3">Never let a profit disappear again!</Typography>
		</Stack>
	
		<Typography align="center" level="body-lg">Enter ticker (or name) of the stock you want to track.</Typography>		
		
		<Box sx={{	flexGrow: 1,
	  				display: 'flex',
	  				gap: 1,
	  				alignItems: 'center',
	  				justifyContent: 'center',
	  				mt: 0.3
	  		}}
	  	>	  	
			
		<Autocomplete
			autoFocus
			ref={selectReference}
			startDecorator={<IcoSearch />}
			placeholder="Type anything"			
			size="lg"
			freeSolo
			open={open}
			options={options}
			getOptionLabel={option => typeof option == 'string' ? option : option.Code + '.' + option.Exchange}
			onChange={(event, newValue) => {
				searchTicker(newValue);
			}}
			handleHomeEndKeys
			sx={{ width: 400 }}
			renderOption={(props, option) => (
				<AutocompleteOption {...props}>
				  <ListItemContent sx={{ fontSize: 'lg' }}>
					{option.Code + '.' + option.Exchange}
					<Typography level="body-sm">
					  {option.Name}, {option.Country}
					</Typography>
				  </ListItemContent>
				</AutocompleteOption>
			  )}			
			  endDecorator={
				isLoading ? (
					<CircularProgress size="sm" sx={{ bgcolor: 'background.surface' }} />
				) : null
			}
		/>

		</Box>


		<Box sx={{	flexGrow: 1,
	  				display: 'flex',
	  				m: 2,
	  				alignItems: 'center',
	  				justifyContent: 'center'
	  		}}
	  	>
			{showAlert && 
				<Alert
					variant="soft"
					color="danger">
					{errorMsg}
					<IconButton variant="soft" size="lg" color="danger" onClick={() => {setshowAlert(false)}}>
					  <IcoCloseRounded />
					</IconButton>
				</Alert>
			}			
		</Box>

		<Box display="flex" justifyContent="center" alignItems="center">
        	<Typography startDecorator={<IcoNote color='danger'/>} level="body-sm" >BETA - be aware...</Typography>
      	</Box>
		
		</React.Fragment>
	)
}

export default AddTicker;